module.exports = __webpack_public_path__ + "static/media/notification-sound.aa22794.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/notification-sound.mp3
// module id = 2831
// module chunks = 3